<div fxFlex fxLayout [class.rtl]="!isEnglish" [class.ltr]="isEnglish">
  <div fxFlex="auto" *ngIf="listOptions.search">
    <form [formGroup]="form">
      <mat-form-field class="width-50" appearance="outline">
        <input type="text" matInput [formControlName]="searchKey" [name]="searchKey" />

        <mat-icon class="search-icon ml-12" matPrefix>search</mat-icon>
      </mat-form-field>
    </form>
  </div>
  <div class="buttons-container" fxFlex fxLayout *ngIf="!listOptions.archivedList">
    <nav mat-tab-nav-bar *ngIf="activeLink">
      <a
        mat-tab-link
        *ngFor="let link of service?.links"
        (click)="activeLink = link?.name; filter(link?.filter)"
        [active]="activeLink == link?.name"
      >
        {{ 'common.' + link?.name | translate }}
      </a>
    </nav>
    <button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      class="menu-trigger-icon"
      *ngIf="(listOptions.exportList || listOptions.importList) && false"
    >
      <mat-icon class="mdi-icon" svgIcon="dots-vertical" [attr.size]="'16px'"></mat-icon>
    </button>

    <mat-menu *ngIf="false" class="export-menu" #menu="matMenu" xPosition="before">
      <div class="d-flex align-items-center justify-content-space-between">
        <span class="export-menu-title">{{ 'common.quick_control' | translate }}</span>
        <button mat-icon-button>
          <mat-icon class="mdi-icon" svgIcon="dots-vertical" [attr.size]="'16px'"></mat-icon>
        </button>
      </div>

      <button
        *ngFor="let exportAsItem of exportAsList"
        mat-menu-item
        (click)="service.exportMultiple(null, true, exportAsItem.type)"
        class="align-items-center in-menu-button"
      >
        <mat-icon class="mdi-icon  in-menu-icon" [svgIcon]="exportAsItem.icon" [attr.size]="'14px'"></mat-icon>
        <span class="in-menu-span">{{ 'common.' + exportAsItem.type + '_file' | translate }}</span>
      </button>

      <button
        *ngIf="listOptions.importList"
        mat-menu-item
        (click)="service.openImportDialog(service)"
        class="align-items-center in-menu-button"
      >
        <mat-icon class="mdi-icon  in-menu-icon" svgIcon="file-download-outline" [attr.size]="'14px'"></mat-icon>
        <span class="in-menu-span">{{ 'common.import_file' | translate }}</span>
      </button>
    </mat-menu>

    <button *ngIf="listOptions.addAction && service?.permission?.create" mat-button (click)="navToCreate()">
      <mat-icon class="icon-lg ml10 v-a-m main-color add-icon ">add_circle</mat-icon>
      <span class="add-text">{{ service.cid + '.create' | translate }}</span>
    </button>
  </div>
</div>
